import apis from '@/apis'

// URL and endpoint constants
const PATH_INSTAGRAM_TAGPAGE = 'api/instagram/tagpage'
const PATH_INSTAGRAM_USERPAGE = 'api/instagram/userpage'

var IS_HTTPS = false
var BASE_URL = '//bosshogbeta.adaptconcepts.com/october/'
var FRONTEND_URL = '//bosshogbeta.adaptconcepts.com/'
if (process.env.NODE_ENV === 'production') {
  IS_HTTPS = true
  if (!window.location ||
    !window.location.hostname) {
    // do nothing
  } else if (window.location.hostname.includes('bosshogcookoff')) {
    BASE_URL = '//bosshogcookoff.com/october/'
    FRONTEND_URL = '//bosshogcookoff.com/'
  } else if (window.location.hostname.includes('bosshoglive.adaptconcepts')) {
    BASE_URL = '//bosshoglive.adaptconcepts.com/october/'
    FRONTEND_URL = '//bosshoglive.adaptconcepts.com/'
  } else if (window.location.hostname.includes('bosshog.adaptconcepts')) {
    BASE_URL = '//bosshog.adaptconcepts.com/october/'
    FRONTEND_URL = '//bosshog.adaptconcepts.com/'
  }
} else {
  // IS_HTTPS = true
  // BASE_URL = '//bosshoglive.adaptconcepts.com/october/'
  IS_HTTPS = false
  BASE_URL = '//localhost/october_bosshog/'
  // FRONTEND_URL = '//localhost:8082/'
}

export default {
  isSecured: IS_HTTPS,

  // release
  baseUrl: BASE_URL + 'adapt/',
  baseUrlInstagram: BASE_URL,
  baseUrlRecaptcha: FRONTEND_URL + 'static/',

  // // staging
  // baseUrl: '//bosshogbeta.adaptconcepts.com/october/singulo/',
  // baseUrlInstagram: '//bosshogbeta.adaptconcepts.com/october/',
  // baseUrlRecaptcha: '//bosshogbeta.adaptconcepts.com/static/',

  // // debug
  // baseUrl: '//localhost:8080/october/singulo/',
  // baseUrlInstagram: '//bosshogbeta.adaptconcepts.com/october/',
  // baseUrlRecaptcha: '//bosshogbeta.adaptconcepts.com/static/',

  // apis
  baseUrlYoutube: '//www.googleapis.com/youtube/v3/',
  baseUrlRecaptchaDebug: '//localhost:8080/bosshogcookoff/static/',

  instagramUser (token, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrlInstagram
      apis.get(PATH_INSTAGRAM_USERPAGE + '/' + token + maxidString)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  instagramTag (tag, maxid) {
    var maxidString = (maxid ? ('/' + maxid) : '')
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrlInstagram
      apis.get(PATH_INSTAGRAM_TAGPAGE + '/' + tag + '/24' + maxidString)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  instagramApi (limit = 24, offset = 0) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = BASE_URL
      apis.get(`api/instagram2/medias/${limit}/${offset}`)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  about () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('about/first')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  aboutWithName (name) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('about/name/' + name)
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0]
        }
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  carousel () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('carousel/subpage/main')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  carouselSubpage (subpage) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('carousel/subpage/' + subpage)
      .then(data => {
        // if (Array.isArray(data) && data.length > 0) {
        //   data = data[0]
        // }
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  company () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('company')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  gallery () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('gallery')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  hotlink () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('hotlink/all')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  sponsor (level) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('staff/level/' + level)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventDetail (showId) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/show/' + showId)
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0]
        }
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventPrevious () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/previous')
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0]
        }
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventUpcoming () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/upcoming')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventAll () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/all')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  eventWithSlug (slug) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('event/slug/' + slug)
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          data = data[0]
        }
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  scheduleDates () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('schedule/date/all')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  scheduleWithDate (date) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('schedule/date/' + date)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  competition () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('signupteamoption/all')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  team () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('signupteam/all')
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  email (recaptcha, name, email, message) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post('email/submit', { recaptcha: recaptcha, name: name, email: email, phone: '-', message: message })
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  subscribe (name, email) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post('email/subscribe', { name: name, email: email })
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  signUpApproved () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.get('signupteam/approved')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  signUpTeam (recaptcha, name, leader, members, memberNames, kcbsNumber,
    address, address2, city, state, zip, county, email, phone, phone2,
    bbq, power, volunteer, competition, locations, tshirt, tshirts, strawberry, kingofwing,
    signature, signAt, amount) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post('signupteam/submit', {
        recaptcha,
        // main
        name,
        leader,
        members,
        memberNames,
        // location
        address,
        address2,
        city,
        state,
        zip,
        county,
        email,
        phone,
        phone2,
        kcbsNumber,
        // options
        bbq,
        power,
        volunteer,
        competition,
        locations,
        tshirt,
        tshirts,
        strawberry,
        kingofwing,
        signature,
        signAt,
        amount
      })
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  signUpJudge (recaptcha, name,
    address, address2, city, state, zip, county, email, phone, phone2, tshirt,
    kcbsCertified, kcbsNumber, kcbsTotal, last1, last2, last3, masterJudge, tableCaptain,
    signature, signAt) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrl
      apis.post('signupjudge/submit', {
        recaptcha,
        // main
        name,
        // location
        address,
        address2,
        city,
        state,
        zip,
        county,
        email,
        phone,
        phone2,
        // options
        tshirt,
        kcbsCertified,
        kcbsNumber,
        kcbsTotal,
        last1,
        last2,
        last3,
        masterJudge,
        tableCaptain,
        signature,
        signAt
      })
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  getRecaptcha () {
    return new Promise((resolve, reject) => {
      apis.forceSecure = this.isSecured
      apis.baseUrl = this.baseUrlRecaptcha
      apis.get('captcha.php')
      .then(data => {
        // reject({ error: 'error' })
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  },

  youtube (path, params) {
    return new Promise((resolve, reject) => {
      apis.forceSecure = true // always secured
      apis.baseUrl = this.baseUrlYoutube
      apis.get(path, params)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/apis/Site.js